import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Cookie from '../components/utils/Cookie'
import utmLinkGenerator from '../components/utils/UTMLinkGenerator'
import ErrorBoundaryComponent from '../components/utils/ErrorBoundaryComponent'
import GA from '../components/utils/GA'
import { Pramon } from '../components/widgets/Pramon'
import LeaderBoard from '../components/widgets/Advert/LeaderBoard'
import Logo from '../components/widgets/Header/Logo'
import Search from '../components/widgets/Header/Search'
import EmailLink from '../components/widgets/Header/EmailLink'
import HotSearch from '../components/widgets/Header/HotSearch'
import SashecAdvertPositionWrapper from '../components/widgets/Advert/SashecAdvertPositionWrapper'
import StickyHalfpage from '../components/widgets/Advert/StickyHalfpage'
import containers from '../containers'
import { detectDevice, isValidDevice } from '../components/utils/Devices'
import { sashecQueuePush, detectSashecDevice } from '../components/utils/SashecHelpers'
import { DEVICES, GA_ENHANCED_ECOMMERCE, GA_TRACKERS, LAYOUT_SECTIONS, WIDGETS } from '../constants'

class LayoutHeadless extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeDynamicLayout: isValidDevice(props.dynamicLayoutCookie) ? props.dynamicLayoutCookie : detectDevice(),
      containers,
      cookies: new Cookie()
    }

    this.dynamicWidgetsLayout = this.getDynamicWidgetsLayout()
    this.updateDynamicLayoutCookie(props.dynamicLayoutCookie)

    if (props.clientSide) {
      const googleAnalytics = new GA(props.widgets.config.ga)

      const pagesTracker = googleAnalytics.getTracker(GA_TRACKERS.PAGEVIEW)
      pagesTracker.set({ dimension2: this.getGADimensionCookie() })
      pagesTracker.pageview('/')

      if (props.widgets.config.ga.trackers.ecommerce) {
        const ecommerceTracker = googleAnalytics.getTracker(GA_TRACKERS.ECOMMERCE)
        ecommerceTracker.require(GA_ENHANCED_ECOMMERCE.ECOMMERCE_PLUGIN)
        this.state.googleAnalytics = ecommerceTracker
      }

      if (props.widgets.config.ga.trackers.events) {
        this.state.eventsTracker = googleAnalytics.getTracker(GA_TRACKERS.EVENTS)
      }

      this.googleAnalytics = googleAnalytics
    }

    utmLinkGenerator.addUtmParams({
      utmSource: props.widgets.layout.utmSource,
      utmContent: props.widgets.layout.utmContent
    })
    this.handleResize = this.handleResize.bind(this)
  }

  componentWillMount () {
    if (!this.props.clientSide) {
      return false
    }

    const {
      meta: {
        sashec: {
          site,
          template,
          area,
          render
        },
        sashecAntiAdblock
      }
    } = this.props.widgets.layout
    const sashecDevice = detectSashecDevice()
    let targets = {
      device: sashecDevice,
      template
    }
    if (this.isAdblockEnabled()) {
      Object.assign(targets, sashecAntiAdblock.targets)
    }
    if (this.props.widgets.layout.meta.sashec[this.props.widgets.config.environment]) {
      Object.assign(targets, this.props.widgets.layout.meta.sashec[this.props.widgets.config.environment])
    }

    const sashecPayload = [
      'group',
      {
        site,
        targets,
        area,
        render
      }
    ]
    sashecQueuePush(sashecPayload)
    this.state.containers.sashec.setState({ payload: sashecPayload })
  }

  componentDidMount () {
    if (this.props.clientSide) {
      window.addEventListener('resize', this.handleResize)
    }
  }

  componentWillUnmount () {
    if (this.props.clientSide) {
      window.removeEventListener('resize', this.handleResize)
    }
  }

  isAdblockEnabled () {
    return this.state.cookies.isSet(this.props.widgets.config.cookies.antiAdblock)
  }

  handleResize () {
    const currentDevice = detectDevice()
    if (this.state.activeDynamicLayout !== currentDevice) {
      this.updateDynamicLayoutCookie(currentDevice)
      this.setState({
        activeDynamicLayout: currentDevice
      })
    }
  }

  getGADimensionCookie () {
    const gaDimensionCookieName = this.props.widgets.config.cookies.gaCustomDimension

    return this.state.cookies.isSet(gaDimensionCookieName) ? this.state.cookies.cookieJar[gaDimensionCookieName] : ''
  }

  updateDynamicLayoutCookie (layout) {
    if (typeof document !== 'undefined') {
      const cookieName = this.props.widgets.config.cookies.dynamicLayout
      const date = new Date()
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000)
      document.cookie = `${cookieName}=${layout}; expires=${date.toGMTString()}`
    }
  }

  getDynamicWidgets () {
    const {
      widgets,
      widgets: {
        config: {
          proxyOptions
        }
      }
    } = this.props

    return {
      [WIDGETS.COMMON.PRAMON]: () => <Pramon widget={widgets.pramon}/>,
      [WIDGETS.COMMON.LEADERBOARD]: () => <LeaderBoard widget={widgets.leaderboard}/>,
      [WIDGETS.COMMON.STRIP]: () => <LeaderBoard widget={widgets.strip}/>,
      [WIDGETS.COMMON.LOGO]: () => <Logo widget={widgets.logo}/>,
      [WIDGETS.COMMON.SEARCH]: () => <Search widget={widgets.search} proxyOptions={proxyOptions}/>,
      [WIDGETS.COMMON.EMAIL_LINK]: () => <EmailLink widget={widgets.emaillink}/>,
      [WIDGETS.COMMON.HOT_SEARCH]: () => <HotSearch widget={widgets.hotsearch}/>,
      [WIDGETS.COMMON.RIGHT_BANNER]: () => <SashecAdvertPositionWrapper widget={widgets.rightbanner}/>,
      [WIDGETS.COMMON.HALF_PAGE]: () => <StickyHalfpage widget={widgets.halfpage}/>,
      [WIDGETS.COMMON.SMART_ADVERT_1]: () => <SashecAdvertPositionWrapper widget={widgets.advertsmart1}/>,
      [WIDGETS.COMMON.SMART_ADVERT_2]: () => <SashecAdvertPositionWrapper widget={widgets.advertsmart2}/>,
      [WIDGETS.COMMON.SMART_ADVERT_3]: () => <SashecAdvertPositionWrapper widget={widgets.advertsmart3}/>,
      [WIDGETS.COMMON.SMART_ADVERT_4]: () => <SashecAdvertPositionWrapper widget={widgets.advertsmart4}/>
    }
  }

  getDynamicWidgetsLayout () {
    return {
      [DEVICES.DESKTOP]: this.getDesktopWidgetsLayout(),
      [DEVICES.TABLET]: this.getTabletWidgetsLayout(),
      [DEVICES.MOBILE]: this.getMobileWidgetsLayout()
    }
  }

  getDesktopWidgetsLayout () {
    return {}
  }

  getTabletWidgetsLayout () {
    return {}
  }

  getMobileWidgetsLayout () {
    return {}
  }

  renderDynamicWidgetsLayout (position) {
    const activeDynamicLayout = this.state.activeDynamicLayout
    const dynamicWidgets = this.getDynamicWidgets()
    return this.dynamicWidgetsLayout[activeDynamicLayout][position].map(widgetId => {
      const widgetComponent = dynamicWidgets[widgetId]()

      if (this.props.serverSideWidgets && !this.props.serverSideWidgets[widgetId.toLowerCase()]) {
        return null
      }

      return (
        <ErrorBoundaryComponent key={widgetId} widgetName={widgetId}>
          {
            React.cloneElement(
              widgetComponent,
              this.state
            )
          }
        </ErrorBoundaryComponent>
      )
    })
  }

  renderTop () {
    return this.renderDynamicWidgetsLayout(LAYOUT_SECTIONS.TOP)
  }

  renderHeader () {
    return this.renderDynamicWidgetsLayout(LAYOUT_SECTIONS.HEADER)
  }

  renderOverContent () {
    return this.renderDynamicWidgetsLayout(LAYOUT_SECTIONS.OVER_CONTENT)
  }

  renderLeftColumn () {
    return this.renderDynamicWidgetsLayout(LAYOUT_SECTIONS.LEFT_COLUMN)
  }

  renderRightColumn () {
    return this.renderDynamicWidgetsLayout(LAYOUT_SECTIONS.RIGHT_COLUMN)
  }

  renderBottom () {
    return this.renderDynamicWidgetsLayout(LAYOUT_SECTIONS.BOTTOM)
  }

  renderOutsideContent () {
    return this.renderDynamicWidgetsLayout(LAYOUT_SECTIONS.OUTSIDE_CONTENT)
  }

  render () {
    return this.props.children
  }
}

LayoutHeadless.propTypes = {
  widgets: PropTypes.object.isRequired,
  layout: PropTypes.string.isRequired,
  clientSide: PropTypes.bool,
  dynamicLayoutCookie: PropTypes.string
}

LayoutHeadless.defaultProps = {
  dynamicLayoutCookie: detectDevice()
}

export default LayoutHeadless
